/**
 * Algolia Search – KCP Price Override
 *
 * Transforms Algolia-rendered product prices on the search page to show the
 * KCP discounted price (strike-through original + discounted amount), matching
 * the same logic used by custom-kcp-price.liquid on PDP and product cards.
 *
 * Reads configuration from #algolia-kcp-config injected in theme.liquid.
 */
(function () {
  'use strict';

  const configEl = document.getElementById('algolia-kcp-config');
  if (!configEl) return;

  const enabled = configEl.dataset.enabled === 'true';
  if (!enabled) return;

  const discountPercent = Number.parseInt(configEl.dataset.discount, 10) || 15;
  const currency = configEl.dataset.currency || 'USD';

  /**
   * Parse a dollar amount string like "$85.00" or "85.00" into cents (integer).
   */
  function parsePriceToCents(text) {
    const cleaned = text.replace(/[^0-9.]/g, '');
    const num = Number.parseFloat(cleaned);
    return Number.isNaN(num) ? 0 : Math.round(num * 100);
  }

  /**
   * Format cents into a dollar string like "$72.25" (no trailing zeros for whole dollars).
   */
  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    // Remove trailing zeros: $72.00 → $72, $72.50 stays $72.50
    const formatted = amount.replace(/\.00$/, '');
    return '$' + formatted;
  }

  /**
   * Transform a single Algolia price node.
   * Supports both InstantSearch (.ais-hit--price) and Autocomplete
   * panel results (.aa-ItemContentPriceCurrent).
   */
  function transformPrice(priceEl) {
    if (priceEl.dataset.kcpApplied === 'true') return;

    const originalText = priceEl.textContent.trim();
    if (!originalText) return;

    const originalCents = parsePriceToCents(originalText);
    if (originalCents <= 0) return;

    // Calculate KCP discounted price (same as Liquid: price * (100 - discount) / 100)
    const discountedCents = Math.round(originalCents * (100 - discountPercent) / 100);
    const originalDisplay = formatMoney(originalCents);
    const discountedDisplay = formatMoney(discountedCents);

    // Keep native container classes; inject only inner KCP markup.
    priceEl.innerHTML =
      '<span class="algolia-kcp-price">' +
        '<span class="currency-USD">' + currency + '</span> ' +
        '<span class="algolia-kcp-price--compare"><s>' + originalDisplay + '</s></span> ' +
        '<span class="algolia-kcp-price--sale">' + discountedDisplay + '</span>' +
      '</span>';

    priceEl.dataset.kcpApplied = 'true';
  }

  /**
   * Scan and transform all visible Algolia price elements.
   */
  function transformAllPrices() {
    const priceEls = document.querySelectorAll('.ais-hit--price, .aa-ItemContentPriceCurrent');
    for (let i = 0; i < priceEls.length; i++) {
      transformPrice(priceEls[i]);
    }
  }

  // Run on initial load
  transformAllPrices();

  // Watch for Algolia re-renders (pagination, sort, filter changes, autocomplete updates)
  new MutationObserver(() => {
    requestAnimationFrame(transformAllPrices);
  }).observe(document.body, { childList: true, subtree: true });
})();
